// "Goes well with" add button. Adds one of the chosen variant tagged with _upsell = data-source.
class JrdgUpsellAdd extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('.jrdg-upsell__add');
    if (this.button && !this.button.dataset.bound) {
      this.button.dataset.bound = '1';
      this.button.addEventListener('click', () => this.add());
      // Dawn's <cart-items>/<cart-drawer-items> treat every bubbling change event as a quantity edit.
      this.addEventListener('change', (event) => event.stopPropagation());
    }
  }

  async add() {
    const id = Number(this.querySelector('.jrdg-upsell__variant')?.value);
    const source = this.dataset.source;
    const drawer = document.querySelector('cart-drawer');
    const useDrawer = drawer && source !== 'cart';
    this.querySelector('.jrdg-upsell__error')?.remove();
    this.setBusy(true);
    try {
      const body = { items: [{ id, quantity: 1, properties: { _upsell: source } }] };
      if (useDrawer) {
        body.sections = drawer.getSectionsToRender().map((s) => s.id);
        body.sections_url = window.location.pathname;
      }
      const res = await fetch(`${routes.cart_add_url}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body),
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok || data.status) {
        this.fail(data.description || data.message);
        return;
      }
      if (!useDrawer) {
        window.location.reload();
        return;
      }
      drawer.renderContents({ id, sections: data.sections });
      this.setBusy(false);
      const container = document.getElementById('CartDrawer');
      const inner = container && container.querySelector('.drawer__inner');
      if (inner && typeof trapFocus === 'function') trapFocus(container, inner);
    } catch (err) {
      this.fail();
    }
  }

  fail(message) {
    this.showError(message || (window.cartStrings && window.cartStrings.error) || 'Could not add this item.');
    this.setBusy(false);
  }

  setBusy(busy) {
    if (!this.button) return;
    this.button.disabled = busy;
    this.button.setAttribute('aria-busy', String(busy));
  }

  showError(message) {
    let el = this.querySelector('.jrdg-upsell__error');
    if (!el) {
      el = document.createElement('p');
      el.className = 'jrdg-upsell__error';
      el.setAttribute('role', 'alert');
      this.append(el);
    }
    el.textContent = message;
  }
}

if (!customElements.get('jrdg-upsell-add')) customElements.define('jrdg-upsell-add', JrdgUpsellAdd);
